import { Injectable } from "@angular/core";
import {
  ToastrService,
  IndividualConfig
} from "ngx-toastr";
import { CommonMethods } from "@services/common.method";

@Injectable({
  providedIn: "root"
})
export class NotificationsService {
  constructor(private toast: ToastrService, private common: CommonMethods) { }

  public showMultiLineError(
    message?: string,
    title?: string,
    override?: Partial<IndividualConfig>
  ) {
    if (CommonMethods.CheckNullOrUndefined(message, true)) {
      message = "Something went wrong.";
    }
    else {
      message = message.trimRight();
      let errorsArr = message.split("\r\n");
      let html = "";
      if (errorsArr.length > 1) {
        errorsArr.map(function (x) {
          html += "<li>" + x + "</li>";
        });
        message = "<ul class='toaster-error-list'>" + html + "</ul>";
        title = title + "s";
      }
    }
    this.toast.error(message, title, override);
  }

    /**
   * @remarks This method is made for future use
   * @param errorObject
   * @param override?: Partial<IndividualConfig>
   */
  public showMultiLineObjectError(
    errorObject: any,
    override?: Partial<IndividualConfig>
  ) {
    let message: string = '';
    let title: string = errorObject["Title"];
    if (CommonMethods.CheckNullOrUndefined(errorObject, false)) {
      message = "Something went wrong.";
    }
    else {
      let html = "";
      let errors = errorObject.Errors;
      Object.keys(errors).forEach(function (key, index) {
        errors[key].forEach(errorMessage => {
          html += "<li>" + key + ' - ' + errorMessage + "</li>";
        });
      });
      message = "<ul class='toaster-error-list'>" + html + "</ul>";
    }
    this.toast.error(message, title, override);
  }
  public warning(
    message?: string,
    title?: string,
    override?: Partial<IndividualConfig>
  ) {
    this.toast.warning(message, title, override);
  }

  public info(
    message?: string,
    title?: string,
    override?: Partial<IndividualConfig>
  ) {
    this.toast.info(message, title, override);
  }

  public success(
    message?: string,
    title?: string,
    override: Partial<IndividualConfig> = { messageClass : "Keepspace" }
  ) {
    this.toast.success(message, title, override);
  }

  public error(
    message?: string,
    title?: string,
    override?: Partial<IndividualConfig>
  ) {
    this.toast.error(message, title, override);
  }

  public clear() {
    this.toast.clear();
  }
}
